import React, { useState } from 'react';
import ReminderCard from '../../../components/Reminders/ReminderCard';
import BlankModal from '../../../components/modals/BlankModal';
import ReminderForm from '../../../components/Reminders/ReminderForm';

const Reminder = ({ reminder, query }) => {
    const [editReminderModalOpen, setEditReminderModalOpen] = useState(false);
    const [selectedReminder, setSelectedReminder] = useState(null);

    // Handler for edit functionality
    const handleEdit = (reminder) => {
        setSelectedReminder(reminder);
        setEditReminderModalOpen(true);
    };

    return (
        <>
            <BlankModal
                open={editReminderModalOpen}
                setOpen={setEditReminderModalOpen}
            >
                <ReminderForm
                    reminder={selectedReminder}
                    householdId={reminder?.household_id}
                    setIsOpen={setEditReminderModalOpen}
                />
            </BlankModal>

            <ReminderCard
                reminder={reminder}
                onEdit={handleEdit}
                query={query}
            />
        </>
    );
};

export default Reminder;
